import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

type CatchUpSearchContextType = {
  searchText: string;
  setSearchText: (value: string) => void;
};

const CatchUpSearchContext = createContext<CatchUpSearchContextType>({
  searchText: '',
  setSearchText: () => void 0,
});

type CatchUpSearchContextProviderProps = {
  children: ReactNode;
};

export const CatchUpSearchContextProvider = ({
  children,
}: CatchUpSearchContextProviderProps) => {
  const [searchText, setSearchText] = useState('');

  const value = useMemo(
    () => ({
      searchText,
      setSearchText,
    }),
    [searchText]
  );

  return (
    <CatchUpSearchContext.Provider value={value}>
      {children}
    </CatchUpSearchContext.Provider>
  );
};

export const useCatchUpSearchContext = () => useContext(CatchUpSearchContext);
